import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Loading } from "@/components/ui-kit";
import { ArrowLeft } from "lucide-react";
import { subjectTheme } from "@/lib/subjects";
import { CourseUnits, openFile } from "@/components/course/CourseUnits";

export function CourseHeader({ course, back }) {
  const t = subjectTheme(course.section, course.section_name);
  const pct = course.hw_total ? Math.round((100 * course.hw_done) / course.hw_total) : 0;
  return (
    <>
      <Link to={back} className="mb-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#4B2BB8] hover:underline" data-testid="course-back"><ArrowLeft className="h-4 w-4" /> All subjects</Link>
      <div className="mb-6 rounded-2xl p-6 text-white" style={{ backgroundColor: t.hex }} data-testid="course-header">
        <div className="font-mono-t text-xs tracking-wider text-white/80">{course.code}</div>
        <h1 className="mt-1 text-3xl font-extrabold">{course.program_name.split(" ")[0]} {course.section_name}</h1>
        <div className="mt-4 flex justify-between text-sm font-semibold text-white/90"><span>{course.hw_done}/{course.hw_total} homework complete</span><span>{pct}%</span></div>
        <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-white/25"><div className="h-full rounded-full bg-white" style={{ width: `${pct}%` }} /></div>
      </div>
    </>
  );
}

export default function StudentCourse() {
  const { program, section } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const load = useCallback(() => api.get(`/courses/${program}/${section}`).then((r) => setCourse(r.data)), [program, section]);
  useEffect(() => { load(); }, [load]);
  if (!course) return <Loading />;
  const open = (it) => {
    if (it.kind !== "homework") return openFile(it);
    navigate(it.is_writing ? `/student/writing/${it.homework_id}` : it.done ? "/student/history" : `/student/exam/${it.homework_id}`);
  };
  return (
    <div className="animate-fade-up" data-testid="student-course-page">
      <CourseHeader course={course} back="/student" />
      <CourseUnits course={course} onOpen={open} onChanged={load} />
    </div>
  );
}
